(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("widget-redirection", [], factory);
	else if(typeof exports === 'object')
		exports["widget-redirection"] = factory();
	else
		root["widget-redirection"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1249);

/***/ }),

/***/ 359:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Spacings = exports.Spacings = {
	    NONE: 'none',
	    SMALL: 'small',
	    MEDIUM: 'medium',
	    BIG: 'big'
	};
	Object.freeze(Spacings);
	
	var SPACING_OPTIONS = exports.SPACING_OPTIONS = [{ label: 'None', value: Spacings.NONE }, { label: 'Spacing small', value: Spacings.SMALL }, { label: 'Spacing medium', value: Spacings.MEDIUM }, { label: 'Spacing big', value: Spacings.BIG }];
	
	var SPACING_PREF = exports.SPACING_PREF = 'spacing';

/***/ }),

/***/ 360:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Containers = exports.Containers = {
	    NONE: 'none',
	    REGULAR: 'regular'
	};
	Object.freeze(Containers);
	
	var CONTAINER_OPTIONS = exports.CONTAINER_OPTIONS = [{ label: 'None', value: Containers.NONE }, { label: 'Regular', value: Containers.REGULAR }];
	
	var CONTAINER_PREF = exports.CONTAINER_PREF = 'container';

/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global window, App */
	
	
	var _containers = __webpack_require__(360);
	
	var _spacings = __webpack_require__(359);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint-disable-next-line no-unused-vars */
	var bd = window.bd;
	/* eslint-disable-next-line no-unused-vars */
	var be = window.be;
	/* eslint-disable-next-line no-unused-vars */
	var b$ = window.b$;
	
	var CxpWidget = function () {
	    function CxpWidget(widget) {
	        _classCallCheck(this, CxpWidget);
	
	        this.widget = widget;
	        this.widgetName = widget.id.replace(/-\d+$/, '');
	
	        this.widget.addEventListener('DOMReady', this.disableClickOnDevelop.bind(this));
	    }
	
	    _createClass(CxpWidget, [{
	        key: 'addHelpTexts',
	        value: function addHelpTexts(propertyKeyTextMap) {
	            var map = Object.keys(propertyKeyTextMap).reduce(function (map, key) {
	                map[key] = { text: propertyKeyTextMap[key] };
	                return map;
	            }, {});
	            this.widget.helpTexts = map;
	        }
	    }, {
	        key: 'onPreferencesSave',
	        value: function onPreferencesSave(event) {
	            // override
	        }
	    }, {
	        key: 'isManageable',
	        value: function isManageable() {
	            var isMasterpage = be && be.utils ? be.utils.module('top.bd.PageMgmtTree.selectedLink')['isMasterPage'] : false;
	            var isInCxpMode = bd.designMode; //Changed be.cmis
	            var isManageable = isInCxpMode && (isMasterpage || this.widget.model.manageable === 'true' || this.widget.model.manageable === '' || this.widget.model.manageable === undefined);
	            return isManageable;
	        }
	    }, {
	        key: 'canEditContent',
	        value: function canEditContent() {
	            /* todo: this is (also) from the backbase content widget, but as I see it, you can only edit the widget if
	            *  you're admin or the creator? Need to check, else change the role here.
	            *  */
	            return this.isManageable() && be.ice.controller && /(?:ADMIN|CREATOR|MANAGER)/.test(this.widget.model.securityProfile);
	        }
	    }, {
	        key: 'prepareCxpPreferences',
	        value: function prepareCxpPreferences() {
	            var _this = this;
	
	            this.widget.addEventListener('preferences-form', function (event) {
	                _this._populatePreferencesForm(event);
	                //*changed
	                if (_this.onCxpPreferencesForm) {
	                    var observer = new MutationObserver(function (mutations) {
	                        var prefForm = document.querySelector('#PreferenceEditorContent');
	                        if (prefForm) {
	                            observer.disconnect();
	                            _this.onCxpPreferencesForm(prefForm);
	                        }
	                    });
	                    observer.observe(document, { attributes: true, childList: true, subtree: true });
	                }
	            });
	            this.widget.addEventListener('preferencesSaved', function (event) {
	                _this.widget.refreshHTML();
	            });
	            this.widget.addEventListener('savePreferenceForm', function (event) {
	                _this.onPreferencesSave(event);
	            });
	        }
	    }, {
	        key: '_populatePreferencesForm',
	        value: function _populatePreferencesForm(event) {
	            var aPrefs = b$.portal.portalModel.filterPreferences(this.widget.model.preferences.array);
	            for (var i = aPrefs.length - 1; i >= 0; i--) {
	                var preferenceItem = aPrefs[i];
	                var prefKey = preferenceItem.name;
	
	                switch (prefKey) {
	                    case _spacings.SPACING_PREF:
	                        this._populateOptions(preferenceItem, _spacings.SPACING_OPTIONS);
	                        break;
	                    case _containers.CONTAINER_PREF:
	                        this._populateOptions(preferenceItem, _containers.CONTAINER_OPTIONS);
	                        break;
	                    default:
	                        this._populateListItems(preferenceItem);
	                }
	            }
	        }
	    }, {
	        key: '_populateOptions',
	        value: function _populateOptions(preferenceItem, options) {
	            preferenceItem.inputType.options = options.map(function (spacing) {
	                return {
	                    label: spacing.label,
	                    value: spacing.value
	                };
	            });
	        }
	    }, {
	        key: '_populateListItems',
	        value: function _populateListItems(preferenceItem) {
	            var prefKey = preferenceItem.name;
	            var sTemplateVariants = this.widget.getPreference(prefKey + 'List');
	
	            if (!sTemplateVariants) {
	                return;
	            }
	
	            var arr = sTemplateVariants.split(',');
	            for (var j = 0, k = 0; j < arr.length; j++, k++) {
	                preferenceItem.inputType.options[k] = {
	                    label: arr[j].trim(),
	                    value: arr[j + 1].trim()
	                };
	                j++;
	            }
	        }
	    }, {
	        key: 'disableClickOnDevelop',
	        value: function disableClickOnDevelop(event) {
	            if (App.Portal.isInDesignMode()) {
	                this.widget.body.querySelectorAll('a').forEach(function (a) {
	                    a.addEventListener('click', function (e) {
	                        return e.preventDefault();
	                    });
	                });
	            }
	        }
	    }]);
	
	    return CxpWidget;
	}();
	
	exports.default = CxpWidget;

/***/ }),

/***/ 969:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _controller = __webpack_require__(970);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Rowan de Zeeuw on 07/09/2018. Used source code from
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Backbase CXPContentWidget to create this extendable version.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  ----------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Author : Backbase R&D - Amsterdam - New York
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Filename : content.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Description:
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Source code for CXP Universal Content Widget
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  ----------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var bd = window.bd; /* eslint-disable-line no-unused-vars */
	var be = window.be; /* eslint-disable-line no-unused-vars */
	var $ = window.jQuery;
	
	var AbstractIceContentController = function (_AbstractWidgetBaseCo) {
	    _inherits(AbstractIceContentController, _AbstractWidgetBaseCo);
	
	    function AbstractIceContentController(widget) {
	        _classCallCheck(this, AbstractIceContentController);
	
	        //if (be.ice && bd && bd.designMode == 'true') {
	        var _this = _possibleConstructorReturn(this, (AbstractIceContentController.__proto__ || Object.getPrototypeOf(AbstractIceContentController)).call(this, widget));
	
	        !window.__TEST__ && _this.renderIceWidget();
	        //}
	        return _this;
	    }
	
	    _createClass(AbstractIceContentController, [{
	        key: 'renderIceWidget',
	        value: function renderIceWidget() {
	            var _this2 = this;
	
	            if (!be.ice) {
	                $('img[src=""], img:not([src])', this.widget.body).addClass('be-ice-hide-image');
	                $(this.widget.body).addClass('be-ice-widget-rendered');
	                return;
	            }
	            this.widget.iceConfig = be.ice.config;
	
	            if (this.cxpWidget.canEditContent()) {
	                this.cxpWidget.prepareCxpPreferences();
	
	                var templateUrl = String(this.widget.getPreference('templateUrl'));
	
	                var enableEditing = function enableEditing() {
	                    // it is possible to swap template for editorial
	                    // here is an example for image template
	                    if (templateUrl.match(/\/image\.html$/)) {
	                        templateUrl = templateUrl.replace(/\/image\.html$/, '/image-editorial.html');
	                    }
	
	                    return be.ice.controller.edit(_this2.widget, templateUrl).then(function (dom) {
	                        $(_this2.widget.body).find('.bp-g-include').html(dom.dom);
	                        return dom.dom;
	                    });
	                };
	
	                // this widget has property rendering example (template: simple.html)
	                // so we need to refresh widget after property 'title' modified
	                this.widget.model.addEventListener('PrefModified', function (oEvent) {
	                    if (oEvent.attrName === 'title') {
	                        enableEditing();
	                    }
	                }, false, this.widget);
	
	                enableEditing();
	            } else {
	                $(this.widget.body).addClass('be-ice-widget-rendered');
	            }
	        }
	    }]);
	
	    return AbstractIceContentController;
	}(_controller2.default);
	
	exports.default = AbstractIceContentController;

/***/ }),

/***/ 970:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _cxpConfig = __webpack_require__(569);
	
	var _cxpConfig2 = _interopRequireDefault(_cxpConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AbstractWidgetBaseController = function () {
	    function AbstractWidgetBaseController(widget) {
	        _classCallCheck(this, AbstractWidgetBaseController);
	
	        this.widget = widget;
	        this.widgetPath = window.App.Portal.getWidgetPath(this.widget);
	        this.cxpWidget = new _cxpConfig2.default(widget);
	    }
	
	    _createClass(AbstractWidgetBaseController, [{
	        key: 'getSelector',
	        value: function getSelector(query) {
	            return this.widget.body.querySelector(query);
	        }
	    }, {
	        key: 'getSelectors',
	        value: function getSelectors(query) {
	            return this.widget.body.querySelectorAll(query);
	        }
	    }]);
	
	    return AbstractWidgetBaseController;
	}();
	
	exports.default = AbstractWidgetBaseController;

/***/ }),

/***/ 1249:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _controller = __webpack_require__(1250);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	App.Widgets.setWidgetStarterInNamespace('WidgetRedirection', _controller2.default);

/***/ }),

/***/ 1250:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _controller = __webpack_require__(969);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var maintenance = "../maintenance.html";
	var HELPERS = window.App.Utils.Helpers;
	var dupApp = "dupApp";
	var duplicate = "duplicate";
	
	var Controller = function (_AbstractIceContentCo) {
	    _inherits(Controller, _AbstractIceContentCo);
	
	    function Controller(widget) {
	        _classCallCheck(this, Controller);
	
	        var _this = _possibleConstructorReturn(this, (Controller.__proto__ || Object.getPrototypeOf(Controller)).call(this, widget));
	
	        _this.init(widget);
	        return _this;
	    }
	
	    _createClass(Controller, [{
	        key: "init",
	        value: function init(widget) {
	
	            var error404page = decodeURI(widget.getPreference('error404page'));
	            var checkOTPsummary = widget.getPreference('checkOTPsummary');
	            var codesExcluded = decodeURI(widget.getPreference('errorCodes'));
	            var instiProductPage = decodeURI(widget.getPreference('instiProductsPage'));
	            var confirmationPage = decodeURI(widget.getPreference('confirmationPage'));
	            var url = "/" + HELPERS.getRelativePath() + confirmationPage;
	            var confirmationDetailsFromStorage = sessionStorage.getItem("confirmationDetails");
	            var otpSummaryFromStorage = sessionStorage.getItem("otpSummary");
	            var decryptionEndpoint = HELPERS.adaptEnvironment(decodeURI(widget.getPreference('apiEndpoint')), true);
	            var decryptionHeadersPref = decodeURI(widget.getPreference('decryptionHeaders'));
	            var decryptionHeaders = JSON.parse(decryptionHeadersPref);
	
	            if (b$.portal.loggedInUserGroup.length === 0) {
	
	                if (checkOTPsummary) {
	                    if (!otpSummaryFromStorage) {
	                        HELPERS.removeFromStorage();
	                        HELPERS.replaceLocation("/" + HELPERS.getRelativePath() + instiProductPage);
	                    }
	                }
	
	                App.PubSub.subscribe("decryptOTPSummary", function (otpSummary) {
	                    if (otpSummary.body && otpSummary.body.referenceNumber) {
	                        if (window.location.href.indexOf(url) < 0) {
	                            if (!confirmationDetailsFromStorage) {
	                                sessionStorage.setItem(dupApp, duplicate);
	                                HELPERS.replaceLocation("/" + HELPERS.getRelativePath() + confirmationPage);
	                            }
	                        }
	                    }
	                });
	
	                if (checkOTPsummary) {
	                    HELPERS.encryptDecrypt(otpSummaryFromStorage, decryptionEndpoint, decryptionHeaders, true, "", "decryptOTPSummary");
	                }
	
	                App.PubSub.subscribe("redirectToErrorPage", function (result) {
	
	                    var isMaintenance = false;
	                    var errorPage = "/" + HELPERS.getRelativePath() + error404page;
	
	                    if (result.status === 400 || result.status === 400 && codesExcluded.includes(result.code)) {
	                        errorPage = result.errorPage;
	                    } else if (result.status !== 404) {
	                        errorPage = result.errorPage;
	                        isMaintenance = true;
	                    }
	
	                    var notHttpResponse = {
	                        status: result.body.status,
	                        description: result.body.description,
	                        message: result.body.message,
	                        withIcon: result.withIcon,
	                        isMaintenance: isMaintenance
	                    };
	
	                    sessionStorage.setItem('notHttpResponse', JSON.stringify(notHttpResponse));
	                    HELPERS.replaceLocation(errorPage);
	                });
	            }
	        }
	    }]);
	
	    return Controller;
	}(_controller2.default);
	
	exports.default = Controller;

/***/ })

/******/ })
});
;


// WEBPACK FOOTER //
// widget-redirection/scripts/widget-redirection.js